var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 5,
    transform: "matrix(-1 0 0 1 46 0)",
    fill: "#F1F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4419 22.4421L18.3142 16.7333C18.1098 16.5445 18.0051 16.3071 18.0002 16.0212C17.9955 15.7356 18.1002 15.4939 18.3142 15.2962C18.5286 15.0987 18.7882 15 19.0932 15C19.3982 15 19.6579 15.0987 19.8722 15.2962L27.6221 21.5794C27.7603 21.7071 27.8579 21.8417 27.9148 21.9833C27.9717 22.1249 28.0002 22.2778 28.0002 22.4421C28.0002 22.6064 27.9717 22.7593 27.9148 22.9009C27.8579 23.0425 27.7603 23.1771 27.6221 23.3048L19.8792 29.7101C19.6745 29.8987 19.4172 29.9953 19.1073 29.9999C18.7976 30.0042 18.5356 29.9076 18.3213 29.7101C18.1072 29.5124 18.0002 29.2729 18.0002 28.9916C18.0002 28.7103 18.1072 28.4707 18.3213 28.273L25.4419 22.4421Z",
    fill: "#A5A5A5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNext);
export default __webpack_public_path__ + "static/media/icon_next.f8bdd3d77f06e5e648edff58eb6ddf49.svg";
export { ForwardRef as ReactComponent };